import { useCmsSlotsContext } from '../context/cmsSlotsContext';
import type { CmsComponentsDisplayProperties, CmsSlotsDeliveryKeys } from '../utils/amplience';

type PageType = 'PLP' | 'SRP';

interface GetProductListingCmsComponentsProps {
  slots: CmsSlotsDeliveryKeys[];
  field: CmsComponentsDisplayProperties;
  type: PageType;
}

export const useGetProductListingCmsComponents = ({ slots, field, type }: GetProductListingCmsComponentsProps) => {
  const { components } = useCmsSlotsContext();

  const seenComponents = new Set();
  const componentsList = Object.entries(components).filter(([key]) => slots.includes(key as CmsSlotsDeliveryKeys));
  const uniqueComponents: [CmsSlotsDeliveryKeys, number][] = [];

  if (!componentsList) return [];

  componentsList.forEach(([key, component]) => {
    if (component?.handlebar) {
      const row = component.handlebar?.input?.displayProperties?.[type]?.[field];

      if (seenComponents.has(row) || row === undefined) return;

      uniqueComponents.push([key as CmsSlotsDeliveryKeys, row]);
      seenComponents.add(row);
    }
    if (component?.dynamic?.displayProperties) {
      const displayProps: Partial<Record<PageType, { [key: string]: any }>> = component.dynamic.displayProperties;
      const row = displayProps[type]?.[field];
      if (seenComponents.has(row) || row === undefined) return;

      uniqueComponents.push([key as CmsSlotsDeliveryKeys, row]);
      seenComponents.add(row);
    }
  });

  return uniqueComponents.sort(([, pos1], [, pos2]) => pos1 - pos2);
};
